import React from "react";
import Users from "../../modules/users";

const UsersPage = () => {
  return <Users />;
};

export default UsersPage;
